export default ({ breakpoints, palette, spacing}) => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: spacing.unit * 3,
    marginRight: spacing.unit * 3,
    [breakpoints.up(400 + spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${spacing.unit * 2}px ${spacing.unit * 3}px ${spacing.unit * 3}px`,
  },
  instructions: {
    marginTop: spacing.unit * 3,
  },
  error: {
    marginTop: spacing.unit * 3,
    color: palette.error.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: spacing.unit * 3,
  },
})
